import { connect } from 'react-redux';
import RoundSelector from '../components/round_selector';
import { changeRound, fetchRounds } from '../actions/leaderboardV2_index';
import { selectIsManagerSite, selectRoundDates } from '../selectors';

const defaultFormatLabel = (round) => round.name;

const mapStateToProps = (state, ownProps) => ({
  rounds: ownProps.rounds ?? state.leaderboardV2.roundList,
  roundDates: selectRoundDates(state),
  selectedRoundId: ownProps.selectedRoundId ?? state.leaderboardV2.roundId,
  formatLabel: ownProps.formatLabel ?? defaultFormatLabel,
  isManagerSite: selectIsManagerSite(state),
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onRoundChange: ownProps.onRoundChange ?? ((newRoundId) => {
    dispatch(changeRound(newRoundId, ownProps.viewMode));
  }),
  // refreshRoundsOnOpen: the page-level selector refetches the round list on
  // open, the same refresh the mobile picker runs (rounds that started or had
  // results released after page load); it resolves to fetchRounds' status so
  // the selector can show its own loading/error state. The details-view
  // selector shows a scorecard's own rounds and never asks.
  onOpen: ownProps.refreshRoundsOnOpen ? () => dispatch(fetchRounds()) : undefined,
});

export default connect(mapStateToProps, mapDispatchToProps)(RoundSelector);
